<template>
    <a-card >
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <template slot="title">
            <span>总览</span>
            
        </template>

        <div style="min-width:1080px;">
            <div>
                <envSelecter v-model="selectedEnv" style="display:inline-flex;"></envSelecter>
                <sysSelecter v-model="sleectedSys" style="display:inline-flex;"></sysSelecter>
                <timeSelecter v-model="selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                <a-button type="primary" style="margin-left:20px;" @click="handleSubmit">查询</a-button>
            </div>

            <a-row :gutter="[16,16]" style="margin-top:20px;">
                <a-col :span='24'>
                    <errorsum ref="errorSumID"></errorsum>
                    <deviceCount ref="deviceCountID" v-show="isPos"></deviceCount>
                    <pvanduv ref="pvanduvID" v-show="!isPos"></pvanduv>

                </a-col>
            </a-row>
            <a-row :gutter="[16,16]" style="margin-top:20px;">
                <a-col :span='12'>
                    <errorchart ref="errorchartID"></errorchart>
                </a-col>
                <a-col :span='12'>
                    <apichart ref="apichartID"></apichart>
                </a-col>
            </a-row>
            
            <a-row :gutter="[16,16]" style="margin-top:20px;">
                <a-col :span='24'>
                    <deviceChart ref="deviceChartID"></deviceChart>
                </a-col>
            </a-row>
            
        </div>
    </a-card>
</template>

<script>
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeSelecter from '../components/timeselecter'
import errorsum from './errorsum'
import pvanduv from './pvanduv'
import errorchart from './errcountchart'
import apichart from './apichart'
import deviceChart from '../components/chinaIpChart'
import deviceCount from './deviceCount'
export default {
    data(){
        return {
            sleectedSys:'',
            selectedEnv:'',
            selectedTimeRange:'',
            isPos:false
        }
    },
    methods:{
        handleSubmit(){
            //如果是收银机统计 设备数 和 uv
            let posNames = ['cloudpos_h5','stablepos_h5','stableposv5_h5','POSASSISTANT_APP-001','cashapp'];
            this.isPos = posNames.indexOf(this.sleectedSys) != -1;
            if(this.isPos){
                this.$refs.deviceCountID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            }
            else{
                this.$refs.pvanduvID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            }
            setTimeout(() => {
                this.$refs.errorSumID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            },1000);
            setTimeout(() => {
                this.$refs.errorchartID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            }, 2000);
            setTimeout(() => {
                this.$refs.apichartID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            }, 3000);
            setTimeout(() => {
                this.$refs.deviceChartID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            }, 4000);
        }
    },
    mounted(){
        
        this.handleSubmit()
    },
    components:{
        sysSelecter,
        timeSelecter,
        pvanduv,
        errorsum,
        errorchart,
        apichart,
        envSelecter,
        deviceChart,
        deviceCount
    }
};
</script>

<style lang="less" scoped>
</style>
